// @mui
import { Stack } from '@mui/material';
import { memo } from 'react';
import { useAuthContext } from '../../../auth/useAuthContext';
// utils
import { hideScrollbarY } from '../../../utils/cssStyles';
import { PERMISSIONS, hasPermission } from '../../../utils/permissions';
//
import { NavListProps, NavSectionProps } from '../types';
import NavList from './NavList';

// ----------------------------------------------------------------------

function NavSectionHorizontal({ data, sx, ...other }: NavSectionProps) {
  const { user } = useAuthContext();

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        mx: 'auto',
        ...hideScrollbarY,
        ...sx,
      }}
      {...other}
    >
      {data.map((group) => {
        if (group.permission && !hasPermission(user, group.permission)) {
          return <></>;
        }

        return <Items key={group.subheader} items={group.items} />;
      })}
    </Stack>
  );
}

export default memo(NavSectionHorizontal);

// ----------------------------------------------------------------------

type ItemsProps = {
  items: NavListProps[];
};

function Items({ items }: ItemsProps) {
  return (
    <>
      {items.map((list) => (
        <NavList
          key={list.title + list.path}
          data={list}
          depth={1}
          hasChild={!!list.children}
        />
      ))}
    </>
  );
}
